<div class="row mb-2">
    <div class="col-6"></div>
    <div class="col-6 d-flex justify-content-end">
        <div class="btn-group">
            <input type="text" class="form-control form-control-sm" placeholder="{{'search.placeholder' | translate}}" [(ngModel)]="searchQuery">
            <button class="btn btn-sm btn-outline-secondary" type="button" (click)="searchQuery = ''"><i
                    class="fa fa-times"></i></button>
        </div>
    </div>
</div>
<div class="custom-scroll-style" style="max-height: 350px; overflow-y: auto; overflow-x: hidden;">
    <table class="table table-striped table-bordered table-curved mb-0">
        <thead class="sticky-header">
        <tr>
            <th class="text-center" style="border-top: 0; width: 30px;">
                <input type="checkbox" class="form-check-input m-2"
                       [(ngModel)]="selectAll"
                       (change)="doSelectAll()">
            </th>
            <th> {{ 'study-editor.study-dataset.instance-table-selector.trial-instance' | translate }}
            </th>
            <th> {{ 'study-editor.study-dataset.instance-table-selector.location-name' | translate }}
            </th>
        </tr>
        </thead>
        <tbody>
            @for (instanceModel of studyInstanceItems | filter:searchQuery:'locationName'; track instanceModel.instanceId) {
                <tr>
                    <td>
                        <input type="checkbox" class="form-check-input m-1"
                               [(ngModel)]="instanceModel.isChecked">
                    </td>
                    <td>
                        {{ instanceModel.instanceNumber }}
                    </td>
                    <td>
                        {{ instanceModel.locationName }}
                    </td>
                </tr>
            } @empty {
                <tr>
                    <td colspan="4" class="text-center text-muted">
                        <span> {{ 'study-editor.study-dataset.instance-table-selector.empty' | translate }}</span>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
